export default class WebStorage {
  constructor () {
    /**
    * 利用するstorageプロパティを格納（localstorage）
    * @type {any}
    * @private
    */
    this.storage = window.localStorage
  }
  /**
  * keyに紐づけて値をstorageに保存する
  * @param  {string} key storageへ保存するkey
  * @param  {any} value 保存したい値。storage格納時には全て文字列として保存する
  */
  setData (key, value) {
    this.storage.setItem(key, JSON.stringify(value))
  }
  /**
  * keyに一致、保存された値を返す
  * @param  {string} key storageへ保存するkey
  * @returns {json} jsonをparseして返す
  */
  getData (key) {
    return JSON.parse(this.storage.getItem(key))
  }
  /**
  * 指定keyで保存されている値があるかどうかチェック
  * @param  {string} key storageへ保存するkey
  * @returns  {boolean} 存在する
  */
  hasData (key) {
    const item = this.getData(key)
    if (typeof item !== 'undefined' && item !== null && item !== '') return true
    else return false
  }
  /**
  * 指定keyで保存されている値を削除する
  * @param  {string} key storageから削除するkey
  */
  removeData (key) {
  }
  /**
  * storageを全て削除する
  */
  clear () {
  }
}



// WEBPACK FOOTER //
// ./src/modules/WebStorage.js